import { AfterViewInit, Component, ElementRef, OnDestroy, input, viewChild } from '@angular/core';

@Component({
  selector: 'app-processing-dialog',
  standalone: true,
  templateUrl: './processing-dialog.component.html',
})
export class ProcessingDialogComponent implements AfterViewInit, OnDestroy {
  readonly title = input.required<string>();
  readonly message = input('Please wait until processing finishes.');
  private readonly dialog = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

  ngAfterViewInit(): void {
    this.dialog().nativeElement.showModal();
  }

  ngOnDestroy(): void {
    this.dialog().nativeElement.close();
  }
}
